import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import SaleOrderDataEntryPopup from "../../salesOrderDataEntry/common/SaleOrderDataEntryPopup";
import { Button } from 'devextreme-react/button';
const CustomerOrdersResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const [currentLayout, setCurrentLayout]= useState("Default");

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "776fb077-74ce-4682-84e7-c0bb792bedef";
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const [showPopup, setShowPopup] = useState({id:null,visible:false});
    const onSelectionChanged = ({ selectedRowsData }) => {
        setShowPopup({id:selectedRowsData[0].rowid,visible:false});
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="recordNumber" caption='Record#'></Column>
                <Column dataField="transactiontype" caption='Type' ></Column>
                <Column dataField="transactionnumber" caption='Transaction.#' ></Column>
                <Column dataField="transactiondate" dataType="date" format="MM/dd/yyyy" caption='Order Date' ></Column>
                <Column dataField="shippingdate" dataType="date" format="MM/dd/yyyy" caption='Ship Date' ></Column>
                <Column dataField="stage" caption='Stage' ></Column>
                <Column dataField="state" caption='State' ></Column>
                <Column dataField="itemTotal" format={{
                    type: 'currency',
                    precision: 2
                }} caption='ItemTotal' ></Column>
                <Toolbar>
                 <Item location="before">
                     <Button text="Edit" disabled={!showPopup.id} type="default" onClick={()=>setShowPopup(prevFormData=>({...prevFormData, visible:true}))} />
                 </Item>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <SaleOrderDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CustomerOrdersResult);